<div class="access-alert-modal">
  <button class="close-btn" aria-label="Close" (click)="onClose()">
    <app-icon name="close" colour="black" />
  </button>

  <h2 class="alert-title">Access alert!</h2>

  <div class="image-wrapper">
    <img src="assets/images/Alert-Speaker.webp" alt="Alert Speaker" class="alert-speaker-icon" />
  </div>

  @if (hasNoActiveButFormerLearners) {
    <p class="description">
      You currently have no active learners linked to your profile. Your children who are no longer active have been
      moved to the
      <strong>Former learners</strong> section under Enrolment.
    </p>
    <p class="support-text">
      If you believe this was a mistake, please contact
      <a class="support-link" (click)="onContactSupport()">Support</a> for assistance.
    </p>
  } @else {
    <p class="description">
      {{ description }}
    </p>

    @if (hasGrantedChildren) {
      <div class="change-group">
        <h3 class="change-title">You now have access to:</h3>
        <div class="children-list">
          @for (child of grantedChildren; track child.learner.id) {
            <div class="child-item">
              <app-learner-avatar [learner]="child.learner" [size]="29" />
              <span class="child-name">{{ child.learner.firstname }}</span>
            </div>
          }
        </div>
      </div>
    }

    @if (hasRevokedChildren) {
      <div class="change-group">
        <h3 class="change-title">You no longer have access to:</h3>
        <div class="children-list">
          @for (child of revokedChildren; track child.learner.id) {
            <div class="child-item">
              <app-learner-avatar [learner]="child.learner" [size]="29" />
              <span class="child-name">{{ child.learner.firstname }}</span>
            </div>
          }
        </div>
      </div>
    }

    @if (showNoLearnersEmptyState) {
      <p class="empty-state">There are no learners assigned.</p>
    }

    @if (supportMessageRequiresAccessRequest) {
      <p class="support-text">
        If you believe this was a mistake or need to request access again, please contact
        <a class="contact-link" (click)="onContactAdmin()">{{ adminName }}</a> for access, or
        <a class="support-link" (click)="onContactSupport()">Support</a> for assistance.
      </p>
    } @else {
      <p class="support-text">
        If you believe this was a mistake, please contact
        <a class="contact-link" (click)="onContactAdmin()">{{ adminName }}</a> directly, or
        <a class="support-link" (click)="onContactSupport()">Support</a> for assistance.
      </p>
    }
  }

  <button class="primary full understand-btn" (click)="onUnderstand()">I understand</button>
</div>
